const KINDERGARTEN = 0;
const HIGHEST_GRADE = 12;

const gradeName = (grade) => (grade === KINDERGARTEN ? "K" : String(grade));

// "4-12", "K-2", "5": a missing lower bound reads K, a missing upper one 12.
export const gradeRange = ({ grade_min: min, grade_max: max }) => {
  const low = gradeName(min ?? KINDERGARTEN);
  const high = gradeName(max ?? HIGHEST_GRADE);
  return low === high ? low : `${low}-${high}`;
};

export const gradeLabel = (set) => `Grade ${gradeRange(set)}`;

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

// A question count the server sent and can be shown: an integer, 0 or more.
// Anything else (an older API without the field) shows no count at all.
export const isQuestionCount = (count) => Number.isInteger(count) && count >= 0;

export const questionCountLabel = (count) => plural(count, "Question", "Questions");

export const questionSetCountLabel = (count) => plural(count, "Question Set", "Question Sets");

export const ALL_GRADES = "all";
const GRADES = Array.from({ length: HIGHEST_GRADE + 1 }, (_, grade) => grade);

const coversGrade = ({ grade_min: min, grade_max: max }, grade) =>
  (min == null || min <= grade) && (max == null || grade <= max);

const gradeOfValue = (value) => (value === "K" ? KINDERGARTEN : Number(value));

export const setsForGrade = (sets, value) =>
  value === ALL_GRADES ? sets : sets.filter((set) => coversGrade(set, gradeOfValue(value)));

const gradeOptionName = (grade) => (grade === KINDERGARTEN ? "Kindergarten" : `Grade ${grade}`);

// "All Grades (N)", then each grade at least one set covers, with its count.
export const gradeOptions = (sets) => {
  const covered = GRADES.map((grade) => ({ grade, count: sets.filter((set) => coversGrade(set, grade)).length }))
    .filter(({ count }) => count > 0)
    .map(({ grade, count }) => ({ value: gradeName(grade), label: `${gradeOptionName(grade)} (${count})` }));
  return [{ value: ALL_GRADES, label: `All Grades (${sets.length})` }, ...covered];
};
